//Dashboard
export const DASHBOARD_ROUTE = '/r/dashboard';
export const MACHADALO_DASHBOARD_ROUTE = '/r/dashboard/machadalo';
export const CLIENT_DASHBOARD_ROUTE = '/r/dashboard/client';

//Manage Supplier
export const MANAGE_SUPPLIER = '/r/manageSupplier/';
export const DASHBOARD_SUPPLIER = '/dashboard';
export const CREATE_SUPPLIER = '/create/:type';
export const SUPPLIER_LOGIN = '/login';
export const COMMON_HOME = '/:type/home';
export const COMMON_HOME_SEARCH = '/:type/home/:state';
export const SOCIETY_HOME = '/society/home';
export const SOCIETY_HOME_SEARCH = '/society/home/:state';
export const SOCIETY = '/society';
export const SOCIETY_SINGLE = '/society/:id';
export const CORPORATE = '/corporate';
export const CORPORATE_SINGLE = '/corporate/:id';
export const GYM = '/gym';
export const GYM_SINGLE = '/gym/:id';
export const SALON = '/salon';
export const SALON_SINGLE = '/salon/:id';
export const BUSSHELTER = '/busshelter';
export const BUSSHELTER_SINGLE = '/busshelter/:id';
export const RETAILSHOP = '/retailshop';
export const RETAILSHOP_SINGLE = '/retailshop/:id';
export const EDUCATION_INSTITUTE = '/education-institute';
export const EDUCATION_INSTITUTE_SINGLE = '/education-institute/:id';
export const HORDING = '/hording';
export const HORDING_SINGLE = '/hording/:id';
export const BUS = '/bus';
export const BUS_SINGLE = '/bus/:id';
export const GANTRY = '/gantry';
export const GANTRY_SINGLE = '/gantry/:id';
export const RADIO_CHANNEL = '/radio-channel';
export const RADIO_CHANNEL_SINGLE = '/radio-channel/:id';
export const TV_CHANNEL = '/tv-channel';
export const TV_CHANNEL_SINGLE = '/tv-channel/:id';
export const CORPORATES = '/corporates';
export const CORPORATES_SINGLE = '/corporates/:id';
export const HOSPITAL = '/hospital';
export const HOSPITAL_SINGLE = '/hospital/:id';

export const ROUTESNAME = {
  opsDashboard: '/opsdashboard',
  bookingPlan: '/booking-plan',
  templateShare: '/template-share',
  contactList: '/contact-list',
};
